import { S3Client } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";

export const s3Uploader = async (
  s3Data,
  item,
  index,
  onProgress = () => {},
  onComplete = () => {},
  onError = () => {},
) => {
  const { bucketName, region, accessKeyId, secretAccessKey, s3Path } =
    s3Data;

  const S3 = new S3Client({
    region,
    credentials: { accessKeyId, secretAccessKey },
  });

  const params = {
    Bucket: bucketName,
    Key: `${s3Path}${item.filename}`,
    Body: item.file,
    ContentType: item.file.type,
  };

  const upload = new Upload({ client: S3, params });

  onProgress(index, 0);

  upload.on("httpUploadProgress", (p) => {
    const percent = Math.round((p.loaded / p.total) * 100);
    onProgress(index, percent);
  });

  try {
    await upload.done();
    onComplete(index);
  } catch (err) {
    onError(index, err);
  }
};
